import Typography from '@mui/material/Typography';
import Alert from '@mui/material/Alert'
import React from 'react'

const AlertComponent = (props) => {
    const {
        title,
        className = "",
        typographyProps = {},
        children,
        ...rest
    } = props;
    return (
        <Alert className={className} {...rest}>
            <Typography {...typographyProps}>
                {title}
            </Typography>
            {children}
        </Alert>
    )
}

export default AlertComponent